export default __webpack_public_path__ + "static/media/cloth3.ae42ba74.webp";